import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  ENTRY_ATR_BUCKETS,
  buildBucketPerformance,
  getTradeEntryPctAtr,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceByEntryPercentageOfAtrWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceByEntryPercentageOfAtrWidget: React.FC<PerformanceByEntryPercentageOfAtrWidgetProps> = ({ 
  timeRange, 
  size,
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: ENTRY_ATR_BUCKETS, metric: getTradeEntryPctAtr }),
    [timeRange, trades]
  );

  return <BucketPerformanceList result={perfData} size={size} pctFormatter={(item) => `${item.pct.toFixed(2)}%`} showOverlay={false} />;
};